import React, { createContext, useContext, useState } from 'react';

const ShippingProfileContext = createContext();

export const ShippingProfileProvider = ({ children }) => {
  const [shippingProfile, setShippingProfile] = useState({
    id: 0,
    name: '',
    status: 'inactive',
    fulfillment_center_id: null,
  });
  const [shipmentLocation, setShipmentLocation] = useState({ name: '', address: '' });
  const [selectedZones, setSelectedZones] = useState([]);
  const [selectedCarriers, setSelectedCarriers] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [fulfillmentCenters, setFulfillmentCenters] = useState([]);
  const [suggestedCarriers, setSuggestedCarriers] = useState([]);
  const [saving, setSaving] = useState(false);

  const onSelectZone = (zoneData) => {
    setSelectedZones((prevZones) => [...prevZones, zoneData]);
  };

  return (
    <ShippingProfileContext.Provider
      value={{
        shippingProfile,
        setShippingProfile,
        shipmentLocation,
        setShipmentLocation,
        selectedZones,
        setSelectedZones,
        selectedCarriers,
        setSelectedCarriers,
        validationErrors,
        setValidationErrors,
        fulfillmentCenters,
        setFulfillmentCenters,
        saving,
        setSaving,
        onSelectZone,
        suggestedCarriers,
        setSuggestedCarriers
      }}
    >
      {children}
    </ShippingProfileContext.Provider>
  );
};

export const useShippingProfile = () => {
  const context = useContext(ShippingProfileContext);
  return context;
};